// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"8":"98955896","24":"11589f8d","71":"e511b7f1","249":"1637ebc2","481":"cbe6c431"}[chunkId] + ".js";
};